import { addDays, addMonths, addWeeks } from "date-fns";
import type { CalendarLayout } from "./calendarEventNavigation";

/** Move the calendar's anchor date by one visible period in either direction. */
export function shiftCalendarDate(date: Date, layout: CalendarLayout, direction: -1 | 1): Date {
  if (layout === "day") return addDays(date, direction);
  if (layout === "week") return addWeeks(date, direction);
  // Month and Agenda both expose a month-sized period in react-big-calendar.
  return addMonths(date, direction);
}
